import * as React from 'react';

import type { UseCurriculum_LearnerProgressFragment as LearnerProgress } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/dpmSharedFragments';
import { isCourseFailed, roundGrade } from 'bundles/degree-home/components/v3-dpm/lib/gradeUtils';
import { METADATA_SEPARATOR, MetadataTypography } from 'bundles/program-loggedin-shared/components/Metadata';

import _t from 'i18n!nls/degree-home';

/** Extra learner information associated with a completed course  */
const CompletionMetadata: React.VFC<{ learnerProgress: LearnerProgress }> = ({ learnerProgress }) => {
  const { grade, takenInTerm, state } = learnerProgress;

  if (!grade || !takenInTerm || isCourseFailed(grade, state)) {
    return null;
  }

  const roundedGrade = roundGrade(grade);

  return (
    <div>
      <MetadataTypography inline>{_t('Taken in #{term}', { term: takenInTerm.partnerTermName })}</MetadataTypography>
      {METADATA_SEPARATOR}
      <MetadataTypography inline color="success">
        {_t('Grade: #{grade}%', { grade: roundedGrade })}
      </MetadataTypography>
    </div>
  );
};

export default CompletionMetadata;
